import { render, staticRenderFns } from "./MarqueeNotice.vue?vue&type=template&id=be40b640&scoped=true"
import script from "./MarqueeNotice.vue?vue&type=script&lang=js"
export * from "./MarqueeNotice.vue?vue&type=script&lang=js"
import style0 from "./MarqueeNotice.vue?vue&type=style&index=0&id=be40b640&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be40b640",
  null
  
)

export default component.exports